<div class="container custom-container">
  <div class="row">
      <div class="col-auto p-0">
          <app-sidenav></app-sidenav>
      </div>

      <div class="col p-0">
          <div class="p-0 mt-0" style="background-color: #fff;width: 100%;height: 100%;">
              <app-header></app-header>
              <div class="main-block">





                  <!-- <div class="dashboard-container" *ngIf="this.UserDtls == 1">
      <h1> Admin</h1>
      <div style="height: 50px;"></div>
      <div class="cards-container">
          <div class="rows">
              
              <div class="card card-1">
                  
                  <div>
                      <img src="../../assets/img/active.png">
                      <div class="card-number">100K</div>
                  </div>
                  <div class="card-title">Active Users and Inactive Users of the Organizations</div>
              </div>
              <div class="card card-2">
                  <div>
                      <img src="../../assets/img/announ.png">
                      <div class="card-number">100K</div>
                  </div>
                  <div class="card-title">Number of Announcements
                      in that Month</div>
              </div>
              <div class="card card-3">
                  <div>
                      <img src="../../assets/img/news.png">
                      <div class="card-number">100K</div>
                  </div>
                  <div class="card-title">Number of News in that Month</div>
              </div>
          </div>
          <div class="rows">
              <div class="card card-4">
                  <div>
                      <img src="../../assets/img/calender.png">
                      <div class="card-number">100K</div>
                  </div>
                  <div class="card-title">Number of Events in that Month</div>
              </div>
              <div class="card card-5">
                  <div>
                      <img src="../../assets/img/id.png">
                      <div class="card-number">100K</div>
                  </div>
                  <div class="card-title">Number of ID cards downloaded Color Theme</div>
              </div>

          </div>
      </div>

  </div> -->
  <h3 >Activity Overview </h3> 
  <div class="upper-parents">
                     
    <div class="helpdesk">
     
      <div class="helpdesk-child">
        <div class="flex" style="display: flex; justify-content: space-between;width: 100%;">
        <div class="title">Tickets  </div>
          <span style="justify-content: flex-end;"> <select name="" id="" style="text-decoration: none;border: none;font-size: 1rem;outline: none; color: #777f8a
             " (change)="onSelectionChange($event,'HelpDesk')"><option value="Today">Today</option>
              <option value="Week">Week</option>
              <option value="Month">Month</option>
              <option value="Year">Year</option></select></span>
        </div>
        <mat-icon matBadge="{{ this.helpDeskcount}}" [routerLink]="['/helpdesk']" class="tickets-icon" style="cursor: pointer;" matBadgeColor="primary" matBadgeColor="warn" matBadgePosition="after" >confirmation_number</mat-icon>
 
        <div class="count"  (click)="showList()" style="cursor: pointer;">
<div class="row">
<div class="col-6">
<h4>Yet to Assign: <span class="num">{{helpDeskYetToAssignCount}}</span></h4> 
</div>
<!-- <div class="col-6">
<h4>On Hold : <span class="num">{{completedCount}}</span></h4> 
</div>
<div class="col-6">
<h4>Yet To start : <span class="num">{{completedCount}}</span></h4> 
</div> -->
<div class="col-6">
<h4 class="right">Active : <span class="num">{{progressCount}}</span></h4>

</div>  
</div> 
<div class="show">
<div class="row" >
<div class="col-6">
  <h4>Assigned: <span class="num">{{helpDeskAssignedCount}}</span></h4>  
</div>
<!-- <div class="col-6">
  <h4>On Hold : <span class="num">{{completedCount}}</span></h4> 
</div>
<div class="col-6">
  <h4>Yet To start : <span class="num">{{completedCount}}</span></h4> 
</div> -->
<div class="col-6">
  <h4 class="right">On Hold: <span class="num">{{helpDeskOnHoldCount}}</span></h4>  
</div>  
</div>  

<div class="row">
  <div class="col-6">
    <h4>Completed : <span class="num">{{completedCount}}</span></h4> 
  </div>
  <!-- <div class="col-6">
    <h4>On Hold : <span class="num">{{completedCount}}</span></h4> 
  </div>
  <div class="col-6">
    <h4>Yet To start : <span class="num">{{completedCount}}</span></h4> 
  </div> -->
  <div class="col-6">
    <h4 class="right">Cancelled : <span class="num">{{helpDeskCancelledCount}}</span></h4>  
  </div>  
  </div>  
</div>
        </div>
      </div>

      <div class="helpdesk-child">
        <div class="flex" >
          <div class="title"> Active Announcement  </div>
          <span style="justify-content: flex-end;"> <select name="" id="" style="text-decoration: none;border: none;font-size: 1rem;outline: none; color: #777f8a;
          " (change)="onSelectionChange($event,'Announcement')"><option value="Today">Today</option>
            <option value="Week">Week</option>
            <option value="Month">Month</option>
            <option value="Year">Year</option></select></span>
        </div>
        <mat-icon matBadge="{{ this.annoncementCount}}" [routerLink]="['/Announcement']" class="tickets-icon" matBadgeColor="primary" matBadgeColor="warn" matBadgePosition="after" style="cursor: pointer;" >campaign</mat-icon>
        <div class="count">
          
        

        <div class="row">
          <div class="col-6">
            <h4> Total : <span class="num">{{this.AnnouncementCount.isActive}}</span></h4> 
          </div>
          <div class="col-6">
            <h4 class="right">Viewed : <span class="num">{{annviewedCount}}</span></h4>  
          </div>  
          </div>  

</div>

       
      <!-- <div class="helpdesk-child">
        <div class="title">Tickets this Week</div>
        <mat-icon matBadge="588" matBadgeColor="primary" matBadgeColor="warn" matBadgePosition="after" style="margin: 20px;color: #2196F3; font-size: 38px;">confirmation_number</mat-icon>
        <div class="count">
          <p> <mat-icon color="primary" style="color: green;">check_circle</mat-icon> Completed: 225</p>
          <p> <mat-icon class="progress-icon" color="accent" >autorenew</mat-icon> In Progress: 90</p>
        </div>
      </div>
      <div class="helpdesk-child">
        <div class="title">Tickets this Month</div>

        <mat-icon matBadge="588" matBadgeColor="primary" matBadgeColor="warn" matBadgePosition="after" style="margin: 20px;color: #2196F3; font-size: 38px;">confirmation_number</mat-icon>
        <div class="count">
          <p><mat-icon color="primary" style="color: green;">check_circle</mat-icon>
            Completed: 75</p>
          <p> <mat-icon class="progress-icon" color="accent" >autorenew</mat-icon>In Progress: 10</p>
        </div>
      </div>
      <div class="helpdesk-child">
        <div class="title">Tickets this Year</div>

        <mat-icon matBadge="588" matBadgeColor="primary" matBadgeColor="warn" matBadgePosition="after" style="margin: 20px;color: #2196F3; font-size: 38px;">confirmation_number</mat-icon>
        <div class="count">
          <p><mat-icon color="primary" style="color: green;">check_circle</mat-icon> Completed: 725</p>
          <p> <mat-icon class="progress-icon" color="accent" >autorenew</mat-icon>In Progress: 190</p>
        </div>
      </div> -->
    </div>
  </div>

<!-- 
  <h3>Overview </h3> -->
                  <!-- <div class="upper-parent" style="display: flex; justify-content: space-between; padding: 20px;">
                      
                      <div class="active-links">
                       
                          <div>
                              
                          </div>
                          <div></div>
                          <div></div>
                      </div>
                      <div class="my-task">
                          <h3>My Task</h3>
                      </div>
                  </div> -->
                  <div class="upper-parent" >
                    
                      <!-- Quick Links Section -->
                      <div class="quick-links">
                      
                      
                        
                        <div class="link" style=" align-items: flex-start;">
                           
                          <div  style="width: 100%;"> 
                            <div class="flex" style="display: flex; justify-content: space-between;width: 100%;flex-direction: row;align-items: ceneter;"> <h3>Announcement : {{this.AnnouncementCount.totalCount}}</h3>
                              <div class="flex-right" style="display: flex;gap: 20px;flex-direction: row;">
                               

                              <button type="button" class="btn new-member" 
                            (click)="openAddAnnounceModal()">
                           <img src="assets/img/plus.png" style="width: 20px;height: 20px;"/> New Announcement
                           </button>
                           <div [routerLink]="['/Announcement']" class="view-link" style="margin-bottom: 10px;">View More</div>
                              </div>
                          </div>
                          <br/>
                            <div class="count">
                             <h4>Active: <span>{{ this.AnnouncementCount.isActive}} </span> </h4>
                             <h4>Inactive: <span>{{ this.AnnouncementCount.totalCount - (this.AnnouncementCount.isActive + this.AnnouncementCount.inActive) }}</span> </h4>
                              <h4>Deleted: <span>{{ this.AnnouncementCount.inActive}} </span> </h4>
                            </div> 

                            
                            <!-- <div class="redirection" style="display: flex; justify-content: space-between; align-items: end; width: 100%; padding: 10px;">
                              <span></span>
                              <div [routerLink]="['/Announcement']" class="view-link">View More</div>
                            </div> -->
                            <!-- <div class="mat-elevation-z8 member-table table-container" >
                              <table mat-table [dataSource]="dataSourceAnnouncement" matSort>
                          
                                <ng-container matColumnDef="userName">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Title
                                  </th>
                                  <td mat-cell *matCellDef="let row">{{ row.title }}</td>
                                </ng-container>
                          
                                <ng-container matColumnDef="email">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Short Title
                                  </th>
                                  <td mat-cell *matCellDef="let row" style="width:17%; word-break: break-all;">{{ row.shortTitle }}</td>
                                </ng-container>
                          
                              
                          
                                <ng-container matColumnDef="designation">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Selected usertypes
                                  </th>
                                  <td mat-cell *matCellDef="let row">{{ getUsertype(row.userRoles) }}</td>
                                </ng-container>
                          
                          
                                <ng-container matColumnDef="date">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Signup Date
                                  </th>
                                  <td mat-cell *matCellDef="let row">
                                    {{ row.created_date | date:'dd/MM/yyyy' : 'N/A' }}
                                  </td>
                                </ng-container>
                          
                                
                          
                             
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                              </table>
                            
                            </div> -->
                           
                          </div>
                        </div>
                        
                        <div class="link" style=" align-items: flex-start;">
                          
                          <div  style="width: 100%;"> 
                           <div class="flex" style="display: flex; justify-content: space-between;width: 100%;flex-direction: row;align-items: ceneter;"><h3 >Forms & Application : {{this.SharePointCount.totalCount}}</h3> 
                            
                            <div class="flex-right" style="display: flex;gap: 20px;flex-direction: row;">

                            <button type="button" class="btn new-member" 
                            (click)="openAddMemberModalShare()">
                           <img src="assets/img/plus.png" style="width: 20px;height: 20px;"/> New Forms
                           </button>
                           <div [routerLink]="['/Forms&Applications']" class="view-link" style="margin-bottom: 10px;">View More</div>

                          </div> 
                           </div>
                           
                            <br/>
                           
                            <div class="count">
                              
                              <div ><h4>Active: <span>{{this.SharePointCount.isActive}}</span> </h4></div>
                              <div > <h4>Inactive: <span>{{this.SharePointCount.totalCount  - (this.SharePointCount.inActive+this.SharePointCount.isActive)}}</span> </h4></div>
                              <div ><h4>Deleted: <span>{{ this.SharePointCount.inActive}}</span> </h4></div>
                            </div>
                           
                           
                           
                            <!-- <div class="redirection" style="display: flex; justify-content: space-between; align-items: end; width: 100%; padding: 10px;">
                              <span></span> -->
                             
                            <!-- </div> -->
                            <!-- <div class="mat-elevation-z8 member-table table-container" >
                              <table mat-table [dataSource]="dataSourceSharepoint" >
                          
                                <ng-container matColumnDef="userName">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Title
                                  </th>
                                  <td mat-cell *matCellDef="let row">{{ row.sharePointTitle }}</td>
                                </ng-container>
                          
                                <ng-container matColumnDef="email">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Selected User Type(s)
                                  </th>
                                  <td mat-cell *matCellDef="let row" style="width:17%; word-break: break-all;">{{ getUsertype(row.roleId)}}</td>
                                </ng-container>
                          
                              
                          
                                <ng-container matColumnDef="designation">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Link
                                  </th>
                                  <td mat-cell *matCellDef="let row">
                                    <a [href]="row.sharePointLink" target="_blank" class="view-link">View</a>
                                  </td>
                                </ng-container>
                          
                          
                                <ng-container matColumnDef="date">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Signup Date
                                  </th>
                                  <td mat-cell *matCellDef="let row">
                                    {{ row.createdDate | date:'dd/MM/yyyy' : 'N/A' }}
                                  </td>
                                </ng-container>
                          
                                
                          
                              
                          
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                              </table>
                             
                              
                            </div>
                            -->
                            
                          </div>
                        
                        </div>
                        <div class="link" style=" align-items: flex-start;">
                           
                         
                          <div  style="width: 100%;"> 
                            <div class="flex" style="display: flex; justify-content: space-between;width: 100%;flex-direction: row;align-items: ceneter;"><h3>Members : {{ this.Membercounts.totalCount}}</h3>
                            <div class="flex-right" style="display: flex;gap: 20px;flex-direction: row;">
                              
                               <button type="button" class="btn new-member"
                              (click)="openAddMemberModal()">
                             <img src="assets/img/plus.png" style="width: 20px;height: 20px;"/> New Member
                             </button>
                             <div [routerLink]="['/members']" class="view-link" style="margin-bottom: 10px;">View More</div>

                            </div>
                            </div>
                            <br/>
                            
                       <div class="split" style="display: flex; flex-direction: row; justify-content: space-between;">
                            <div class="count">
                              <div class="title" style="font-size: large;border-bottom: 1px solid black;margin: 3px;">User : {{this.Membercounts.totalCount}}</div>
                              <div ><h4>Active: <span>{{ this.Membercounts.isActive}} </span> </h4></div>
                              <div > <h4>Deleted: <span>{{this.Membercounts.deleted}}</span> </h4></div>
                              <div ><h4>Inactive: <span> {{ this.Membercounts.inActive}} </span> </h4></div>
                              <!-- <div class="right"><h4>Inactive: <span> {{ this.Membercounts.inActive}} </span> </h4></div> -->
                            </div> 
                            <div class="count"  style="display: flex;flex-direction: column;">
                              <div class="title" style="font-size: large;border-bottom: 1px solid black;margin: 3px;">Active User Type : {{totalUsertypeCount}}</div>
                              <div  *ngFor="let role of roleList?.roleType">
                                <h4>{{role.role}}: <span>{{CountDisplay("usertype",role.id)}} </span> </h4>
                              </div>
                              <!-- <div > <h4>User: <span>{{this.Membercounts.deleted}}</span> </h4></div>
                              <div ><h4>Help Desk: <span> {{ this.Membercounts.inActive}} </span> </h4></div> -->
                              <!-- <div class="right"><h4>Inactive: <span> {{ this.Membercounts.inActive}} </span> </h4></div> -->
                            </div> 
                          
                          <div class="count">
                            <div class="count"  style="display: flex;flex-direction: column;">
                              <div class="title" style="font-size: large;border-bottom: 1px solid black;margin: 3px;">Active Category : {{totalCategoryCount}}</div>
                              <div  *ngFor="let item of filterGeneral">
                                <h4>{{item.categoryName}}: <span>{{CountDisplay("category",item.categoryId)}} </span> </h4>
                              </div>
                            <!-- <div ><h4>IT Admin: <span>{{ this.Membercounts.isActive}} </span> </h4></div>
                            <div > <h4>Emergency Team: <span>{{this.Membercounts.deleted}}</span> </h4></div>
                            <div ><h4>Tribal Council: <span> {{ this.Membercounts.inActive}} </span> </h4></div> -->
                            <!-- <div class="right"><h4>Inactive: <span> {{ this.Membercounts.inActive}} </span> </h4></div> -->
                          </div> 
                         
                         
                      </div>

                            <!-- <div  [routerLink]="['/members']" class="redirection" style="text-align: end;padding: 10px;">View</div> -->
                            
                            <!-- <div class="mat-elevation-z8 member-table table-container" >
                              <table mat-table [dataSource]="dataSource" matSort>
                          
                                <ng-container matColumnDef="userName">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Member
                                  </th>
                                  <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
                                </ng-container>
                          
                                <ng-container matColumnDef="email">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Email
                                  </th>
                                  <td mat-cell *matCellDef="let row" style="width:17%; word-break: break-all;">{{ row.email }}</td>
                                </ng-container>
                          
                              
                          
                                <ng-container matColumnDef="designation">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Designation
                                  </th>
                                  <td mat-cell *matCellDef="let row">{{ row.designation }}</td>
                                </ng-container>
                          
                          
                                <ng-container matColumnDef="date">
                                  <th class="mat-table-header" mat-header-cell *matHeaderCellDef>
                                    Signup Date
                                  </th>
                                  <td mat-cell *matCellDef="let row">
                                    {{ row.registerdDate | date:'dd/MM/yyyy' : 'N/A' }}
                                  </td>
                                </ng-container>
                          
                                
                          
                             
                          
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                              </table>
                             
                            </div> -->
                           
                          </div>
                          
                        </div>
                      
                      </div>
                  
                    

                    </div>
                <div class="modal fade" id="newMemberCreate" data-backdrop="static" tabindex="-1" role="dialog"
                aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <!-- Modal Header -->
                      <div class="modal-header">
                        <h4 class="modal-title">New Member</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="hide()">
                          <!-- <img src="assets/img/modal-close.png" /> -->
                          <mat-icon class="inactive-icon" style="color: red;font-size: 27px;">cancel</mat-icon>
                        </button>
                      </div>
                      <!-- Modal body -->
                      <div class="modal-body">
                        <!-- Coupon Discount Form -->
                        <div class="container" *ngIf="addMemberForm">
                          <form [formGroup]="memberForm" (ngSubmit)="memberFormSubmit()">
                            <div class="form-group mb-3">
                              <label for="firstName">First Name<span style="color: red;"> *</span></label>
                              <input type="text" class="form-control signup-input" id="firstName" placeholder="First Name"
                                formControlName="firstName" />
                              <div *ngIf="memberSubmitted && memberControl.firstName.errors" class="ml-2">
                                <div *ngIf="memberControl.firstName.errors.required" class="text-danger">
                                  First Name required
                                </div>
                                <div *ngIf="memberControl.firstName.errors.pattern" class="text-danger">
                                  Avoid using special characters/Numbers and ensure that your first name more than 3 character
                                </div>
                                <div *ngIf="memberControl.firstName.errors.noWhiteSpace" class="text-danger">
                                  First Name required
                                </div>
                              </div>
                            </div>
                            <div class="form-group mb-3">
                              <label for="lastName">Last Name<span style="color: red;"> *</span></label>
                              <input type="text" class="form-control signup-input" id="lastName" placeholder="Last Name"
                                formControlName="lastName" />
                              <div *ngIf="memberSubmitted && memberControl.lastName.errors" class="ml-2">
                                <div *ngIf="memberControl.lastName.errors.required" class="text-danger">
                                  Last Name required
                                </div>
                                <div *ngIf="memberControl.lastName.errors.pattern" class="text-danger">
                                  Avoid using special characters/Numbers and ensure that your last name more than one character
                                </div>
                                <div *ngIf="memberControl.lastName.errors.noWhiteSpace" class="text-danger">
                                  {{ memberControl.lastName.errors.noWhiteSpace }}
                                </div>
                              </div>
                            </div>
            
                            <div class="form-group mb-3">
                              <label for="title">Title<span style="color: red;"> *</span></label>
                              <input type="text" class="form-control signup-input" id="title" placeholder="Title"
                                formControlName="title" />
                              <div *ngIf="memberSubmitted && memberControl.title.errors" class="ml-2">
                                <div *ngIf="memberControl.title.errors.required" class="text-danger">
                                  Title required
                                </div>
            
                                <div
                                  *ngIf="memberControl.title.hasError('minlength') && (memberControl.title.dirty || memberControl.title.touched)"
                                  class="text-danger">
                                  Please ensure that your title more than one character
                                </div>
                                <div *ngIf="memberControl.title.errors.pattern" class="text-danger">
                                  Please ensure that your title have no special characters
                                </div>
                                <div *ngIf="memberControl.title.errors.noWhiteSpace" class="text-danger">
                                  {{ memberControl.title.errors.noWhiteSpace }}
                                </div>
                              </div>
                            </div>
            
                            <!-- <div class="form-group mb-3">
                              <label for="organaisationName">Organization Name<span style="color: red;"> *</span></label>
                              <input type="text" class="form-control signup-input" id="organization" placeholder="Organization Name"
                                formControlName="organaisationName" />
                              <div *ngIf="
                                  memberSubmitted && memberControl.organaisationName.errors
                                " class="ml-2">
                                <div *ngIf="memberControl.organaisationName.errors.required" class="text-danger">
                                  Organization Name required
                                </div>
                                <div *ngIf="memberControl.organaisationName.errors.pattern" class="text-danger">
                                  Please ensure that your Organization Name have no special characters
                                </div>
                                <div
                                  *ngIf="memberControl.organaisationName.hasError('minlength') && (memberControl.organaisationName.dirty || memberControl.organaisationName.touched)"
                                  class="text-danger">
                                  Please ensure that your title more than one character
                                </div>
            
                                <div *ngIf="
                                    memberControl.organaisationName.errors.noWhiteSpace
                                  " class="text-danger">
                                  {{ memberControl.organaisationName.errors.noWhiteSpace }}
                                </div>
                              </div>
                            </div> -->
            
                            <div class="form-group mb-3">
                              <label for="email">Email <span style="color: red;"> *</span></label>
                              <input type="email" class="form-control signup-input" id="email" placeholder="Email"
                                formControlName="email" />
                              <div *ngIf="memberSubmitted && memberControl.email.errors" class="ml-2">
                                <div *ngIf="memberControl.email.errors.required" class="text-danger">
                                  Email required
                                </div>
                                <div *ngIf="memberControl.email.errors.pattern" class="text-danger">
                                  Enter valid email address
                                </div>
                              </div>
                            </div>
            
                            <div class="form-group mb-3">
                              <label for="phoneNo">Phone# <span style="color: red;"> *</span></label>
                              <input type="text" class="form-control signup-input" id="phoneNo" placeholder="Phone"
                                mask="(000)-000-0000" (keydown)="handleKeyDown($event)" formControlName="phoneNo" />
                              <div *ngIf="memberSubmitted && memberControl.phoneNo.errors" class="ml-2">
                                <div *ngIf="memberControl.phoneNo.errors.required" class="text-danger">
                                  Phone required
                                </div>
                                <div *ngIf="memberControl.phoneNo.errors.pattern" class="text-danger">
                                  Enter valid phone number
                                </div>
                              </div>
                            </div>
            
                            <div class="form-group ">
                              <label for="roleType">User Type <span style="color: red;"> *</span></label>
                              <select class="form-control" formControlName="roleType" id="roleType" placeholder="roleType" style="
                                                      padding-left: 15px;" (change)="onListSelect($event)">
                                <option value='' disabled selected>Select User Type</option>
                                <!-- <option value="">Select State</option> -->
                                <option *ngFor="let role of this.roleTypes" value="{{role.id}}">{{role.role}}</option>
                              </select>
                              <div *ngIf="memberSubmitted && memberControl.roleType.errors" class="ml-2">
                                <div *ngIf="memberControl.roleType.errors.required" class="text-danger">
                                  User Type required
                                </div>
                              </div>
                            </div>
                            <div class="form-group ">
                              <label for="roleType">Catagory </label>
                              <select class="form-control" formControlName="parentCategoryId" id="roleType" placeholder="roleType" style="
                                                      padding-left: 15px;" (change)="oncatogorySelect($event)">
                                <option value= 0 >Select Catogory</option>
                                <!-- <option value="">Select State</option> -->
                                <option *ngFor="let role of this.catagoryDropDown" value="{{role.categoryId}}">{{role.categoryName}}</option>
                              </select>
                              
                            </div>
                            <div class="form-group " *ngIf="isPresent">
                              <label for="roleType">Sub Catagory <span style="color: red;"> *</span></label>
                              <select class="form-control" formControlName="subCategoryId" id="roleType" placeholder="roleType" style="
                                                      padding-left: 15px;" >
                                <option value= 0 >Select Sub Catogory</option>
                                <!-- <option value="">Select State</option> -->
                                <option *ngFor="let role of  this.subCatagoryDropDown" value="{{role.categoryId}}">{{role.categoryName}}</option>
                              </select>
                              
                            </div>
            
                            <!-- <div class="form-group mb-3">
                              <label for="address">Address</label>
                              <input type="text" class="form-control signup-input" id="address" placeholder="Address"
                                formControlName="address" />
                              <div *ngIf="
                                  memberSubmitted && memberControl.address.errors" class="ml-2">
                                <div *ngIf="memberControl.address.errors.required" class="text-danger">
                                  Address required
                                </div>
                                <div *ngIf="
                                    memberControl.address.errors.noWhiteSpace
                                  " class="text-danger">
                                  {{ memberControl.address.errors.noWhiteSpace }}
                                </div>
                              </div>
                            </div>
            
                            <div class="form-group mb-3">
                              <label for="city">City</label>
                              <input type="text" class="form-control signup-input" id="city" placeholder="City"
                                formControlName="city" />
                              <div *ngIf="
                                  memberSubmitted && memberControl.city.errors" class="ml-2">
                                <div *ngIf="memberControl.city.errors.required" class="text-danger">
                                  City required
                                </div>
                                <div *ngIf="
                                    memberControl.city.errors.noWhiteSpace
                                  " class="text-danger">
                                  {{ memberControl.city.errors.noWhiteSpace }}
                                </div>
                              </div>
                            </div>
            
                          <div class="form-group mb-3">
                              <label for="state">State</label>
                              <select class="form-control" formControlName="state" id="state" placeholder="state" style="height: 50px;
                                  padding-left: 15px;">
                                <option value="">Select State</option>
                                <option *ngFor="let state of states" value="{{ state }}">{{
                                  state
                                  }}</option>
                              </select>
                              <div *ngIf="
                                  memberSubmitted && memberControl.state.errors" class="ml-2">
                                <div *ngIf="memberControl.state.errors.required" class="text-danger">
                                  State required
                                </div>
                              </div>
                            </div>  
            
                            <div class="form-group mb-3">
                              <label for="zipCode">Zip Code</label>
                              <input type="text" class="form-control signup-input" id="zipCode" placeholder="Zip Code" mask="00000"
                                formControlName="zipCode" />
                              <div *ngIf="
                                  memberSubmitted && memberControl.zipCode.errors" class="ml-2">
                                <div *ngIf="memberControl.zipCode.errors.required" class="text-danger">
                                  Zip Code required
                                </div>
                                <div *ngIf="memberControl.zipCode.errors.pattern" class="text-danger">
                                  Enter valid zip
                                </div>
                              </div>
                            </div>
            
                            <div class="form-group mb-3">
                              <label for="interval">Duration</label>
                              <select class="form-control" formControlName="interval" id="interval">
                                <option>year</option>
                                <option>month</option>
                              </select>
                            </div> -->
                            <div class="footer-modal" style="display: flex; justify-content: flex-end;">
                            <button class="btn button-color btn-md btn-block memberAdd-btn" type="submit" [disabled]="!checkAllFieldsEntered()">
                              <span *ngIf="isLoading" class="spinner-border spinner-border-sm text-light" role="status">
                              </span>
                              <span *ngIf="!isLoading">Add</span>
                            </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal fade" id="newAnnouncementCreate" role="dialog" aria-labelledby="staticBackdropLabel"
              >
      
              <div class="modal-dialog">
                  <div class="modal-content" style="padding: 10px;">
      
                      <div class="modal-header">
                          <h4 class="modal-title">New  Announcement</h4>
                          <button type="button" class="close" data-dismiss="modal" (click)="hide()">
                              <!-- <img src="assets/img/modal-close.png" /> -->
                              <mat-icon class="inactive-icon" style="color: red;font-size: 27px;">cancel</mat-icon>
                          </button>
                      </div>
      
                      <div *ngIf="addAnnouncementForm">
      
                          <form [formGroup]="announcementForm" (ngSubmit)="saveAnnouncement()">
                              <div style="margin: 20px;">
                                  <div class="form-group mb-3">
                                      <label for="firstName">Heading<span style="color: red;"> *</span> </label>
      
                                      <input class="form-control signup-input" formControlName="title"
                                       >
      
                                      <div *ngIf="announcementSubmit && announceControl.title.errors" class="ml-2">
                                          <div *ngIf="announceControl.title.errors.required" class="text-danger">
                                              Title required
                                          </div>
                                          <div *ngIf="announceControl.title.errors.noWhiteSpace" class="text-danger">
                                              {{ announceControl.title.errors.noWhiteSpace }}
                                          </div>
                                          <div *ngIf="announceControl.title.errors.pattern" class="text-danger">
                                              Please ensure title more than one character
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div style="margin: 20px;">
                                  <div class="form-group mb-3">
                                      <label for="firstName">Short Title <span style="color: red;"> *</span> </label>
      
                                      <input class="form-control signup-input" formControlName="shortTitle"
                                        >
      
                                      <div *ngIf="announcementSubmit && announceControl.shortTitle.errors" class="ml-2">
                                          <div *ngIf="announceControl.shortTitle.errors.required" class="text-danger">
                                              Short Title required
                                          </div>
                                          <div *ngIf="announceControl.shortTitle.errors.noWhiteSpace" class="text-danger">
                                              {{ announceControl.shortTitle.errors.noWhiteSpace }}
                                          </div>
                                          <div *ngIf="announceControl.shortTitle.errors.pattern" class="text-danger">
                                          Please ensure Short title more than one character
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div style="margin: 20px;">
                                  <div class="form-group mb-3">
                                      <label for="firstName">Short Description <span style="color: red;"> *</span> </label>
                                      <!-- <mat-form-field style="width: 100%;"> -->
                                      <input class="form-control signup-input" formControlName="shortDescription"
                                          >
                                      <!-- </mat-form-field> -->
                                      <div *ngIf="announcementSubmit && announceControl.shortDescription.errors" class="ml-2">
                                          <div *ngIf="announceControl.shortDescription.errors.required" class="text-danger">
                                              Short Description required
                                          </div>
                                          <div *ngIf="announceControl.shortDescription.errors.noWhiteSpace" class="text-danger">
                                              {{ memberControl.shortDescription.errors.noWhiteSpace }}
                                          </div>
                                          <div *ngIf="announceControl.shortDescription.errors.pattern" class="text-danger">
                                              Please ensure short description more than one character
                                          </div>
                                          
                                      </div>
                                  </div>
                              </div>
                              <div style="margin: 20px;">
                                  <div class="form-group mb-3">
                                    <label for="firstName">SharePoint Link
                                    
                                    </label><br>
                                    <textarea formControlName="sharePointLink"
                                              class="form-control signup-input" 
                                              placeholder="SharePoint Link"
                                              ></textarea>
                                     <div *ngIf="announcementSubmit && announceControl.sharePointLink.errors" class="ml-2">
                                    
                                      <div *ngIf="announceControl.sharePointLink.hasError('pattern')" class="text-danger">
                                        Please enter a valid link.
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                
      
                              <div style="margin: 20px;">
                                  <label for="firstName">Select User Type <span style="color: #ff0000;">*</span></label><br>
                                  <mat-checkbox *ngFor="let role of roleList?.roleType" color="primary"
                                  style="margin-right: 15px;" [checked]="selectedRoles.includes(role.id)"
                                  [disabled]="apiselectedRoles.includes(role.id)"
                                  (change)="toggleRoleSelection(role.id)" >  {{role.role}}</mat-checkbox>
                                  <div *ngIf="isSelectedRoles" class="ml-2">
                                      <div class="text-danger">
                                          Usertype required
                                      </div>
                                  </div>
                              </div>
                             
      
                              <div style="margin: 20px;">
                                  <label for="firstName">Description
                                      <span style="color: red;">*</span></label><br>
                                  <editor apiKey="3utpg99m95qhctxkp123473e8ic0u4gp7hq448q0avxvazor"
                                      formControlName="html" [init]="{
                                              height: 400,
                                              plugins: ['image', 'lists link image table code help wordcount', 'save'],
                                              toolbar:
                                                'undo redo | formatselect | bold italic backcolor | \
                                                alignleft aligncenter alignright alignjustify | \
                                                bullist numlist outdent indent | removeformat | help | save'
                                            }"></editor>
                                  <!-- <editor apiKey="xdkenger2ocg52ups58llhfazuqsfl4o58n4u5umy0k0zsqr"
                                      [disabled]="typeofAnnounce == 'Edit' ?true: false" formControlName="html" [init]="{
                                  height: 400,
                               
                                  plugins: [
                                  'image',
                                  'lists link image table code help wordcount',
                                  'save'
                                  ],
                                  toolbar:
                                  'undo redo | formatselect | bold italic backcolor | \
                                  alignleft aligncenter alignright alignjustify | \
                                  bullist numlist outdent indent | removeformat | help | save',
                                  images_upload_handler: this.uploadImage.bind(this),
                                  file_picker_types: 'image'
                                  
                              }"></editor> -->
                                  <div *ngIf="announcementSubmit && announceControl.html.errors" class="ml-2">
                                      <div *ngIf="announceControl.html.errors.required" class="text-danger">
                                          Description required
                                      </div>
                                      <div *ngIf="announceControl.html.errors.pattern" class="text-danger">
                                          Please ensure content more than one character
                                      </div>
                                  </div>
                                  
                                  <div class="form-group mb-3">
                                      <label for="roleType">Catagory </label>
                                      <select class="form-control" formControlName="catagory" id="roleType" placeholder="roleType" style="
                                                              padding-left: 15px;" (change)="oncatogorySelect($event)">
                                        <option value=0 >Select Catogory</option>
                                        
                                        <option *ngFor="let role of this.catagoryDropDown" value="{{role.categoryId}}"  >{{role.categoryName}}</option>
                                      </select>
                                     
                                      
                                    </div>
                                
                                    <div class="form-group mb-3" *ngIf="isPresent">
                                      <label for="roleType">Sub Catagory <span style="color: red;" > *</span></label>
                                      <!-- <select class="form-control" formControlName="subcatogorycatagory" id="roleType" placeholder="roleType" style="
                                                              padding-left: 15px;" (change)="onSubcatogorySelect($event)">
                                        <option value=0 >Select Sub Category</option>
                                   
                                        <option *ngFor="let role of  this.subCatagoryDropDown" value="{{role.categoryId}}" [disabled]="this.subcategoryMap.includes(role.categoryId)">{{role.categoryName}}</option>
                                      </select> -->
                                      
                                  <!-- <ng-select  style="font-size: 1rem;"
                                    bindLabel="name"                
                                    bindValue="id"
                                    placeholder="Select item"         
                                    formControlName="subcatogorycatagory"
                                    [multiple]="true"              
                                    [closeOnSelect]="false"
                                    (change)="onSelectGroups($event,'sub')" >
                                  
                                   <ng-option *ngFor="let role of SubCategoryWithAll" 
                                   [value]="role.categoryId" 
                                   [disabled]="this.subcategoryMap.includes(role.categoryId) ||allhideSub && role.categoryId !== 'all'">
                                   {{role.categoryName}}
                                  </ng-option>
                                
                                  </ng-select>  -->
                                  <ng-select  class="custom-ng-select"
                                  bindLabel="name"                
                                  bindValue="id"
                                  placeholder="Select item"         
                                  formControlName="subcatogorycatagory"
                                  [multiple]="true"              
                                  [closeOnSelect]="false"
                                  (change)="onSelectGroups($event,'sub')" >
                                <ng-option [value]="'all'" [disabled]="allhideSubAll" *ngIf="subCatagoryDropDown.length!=1"  >
                                  All
                                </ng-option>
                                 <ng-option *ngFor="let role of subCatagoryDropDown" 
                                 [value]="role.categoryId" 
                                 [disabled]="allhideSub || this.subcategoryMap.includes(role.categoryId)">
                                 {{role.categoryName}}
                                </ng-option>
                              
                                </ng-select> 
                                    </div>
                                     <!-- <div class="form-group mb-3" >
                                      <label>Vendor Group</label>
                                      <select class="form-control" id="groupId" formControlName="groupId">
                                          <option value=0 >Select Group</option>
                                        
                                          <option *ngFor="let group of this.groupList" value="{{this.group.id}}" [disabled]="this.vendorMap.includes(group.id) && !this.isShow">{{ group.name }}</option>
                                        </select>
                                      
                                    </div> -->
                                    <div class="form-group mb-3" >
                                      <label for="">Vendor Group</label>
                                      <ng-select  style="font-size: 1rem;"  class="custom-ng-select" 
                                      bindLabel="name"                
                                      bindValue="id"
                                      placeholder="Select item"         
                                      formControlName="groupId"
                                      [multiple]="true"              
                                      [closeOnSelect]="false"
                                       dropdownPosition=bottom
                                      (change)="onSelectGroups($event,'group')" >
                                      <ng-option [value]="'all'" [disabled]="allhidegroupAll" *ngIf="groupList.length!=1"   >
                                        All
                                      </ng-option>
                                     <ng-option *ngFor="let group of groupList" 
                                     [value]="group.id" 
                                     [disabled]="this.allhide==true?true:false"
                                     >
                                     {{ group.name }}
                                    </ng-option>
                                  
                                    </ng-select>   
          
                                       
                                        </div>
                                    
                                    <div class="form-group mb-3">
                                      <Label>Announcement Image <span style="color: red;">*</span></Label><br *ngIf="!isShow">
                                      <a [href]
                                      ="logoDisplay" *ngIf="!isShow"> <span *ngIf="!isShow">view Image</span>
                                      </a><br>
                                      <img [src]="logoDisplay" *ngIf="!isShow" alt="Profile Image" width="50" height="50" style="margin: 4px;" >
                                      <!-- <a [href]="logoDisplay" *ngIf="!isShow"> <span *ngIf="!isShow">view Image</span>
                                      </a><br> -->
                                      <input type="file" (change)="onFileSelect($event)" *ngIf="isShow" formControlName="logoimg" >
                                  </div>
                                  <div class="text-danger" *ngIf="customvalidator"> Please upload an image in GIF, JPEG, or
                                      PNG format. </div>
                                  <div class="footer-modal"> 
                                      <button [disabled]="!checkAllFieldsEntereds()" class="sync-btn">Submit</button>
                                     
                                  </div>
                              </div>
                          </form>
                         
                      </div>
                  </div>
              </div>
      
          </div>
          <div class="modal fade" id="newformCreate" data-backdrop="static" tabindex="-1" role="dialog"
          aria-labelledby="staticBackdropLabel" data-keyboard="false" aria-hidden="true" >
  
          <div class="modal-dialog">
              <div class="modal-content" style="padding: 10px;">
  
                  <div class="modal-header">
                      <h4 class="modal-title">{{typeofSharePoint}} Forms</h4>
                      <button type="button" class="close" data-dismiss="modal" (click)="hide()">
                          <!-- <img src="assets/img/modal-close.png" /> -->
                          <mat-icon class="inactive-icon" style="color: red;font-size: 27px;">cancel</mat-icon>
                      </button>
                  </div>
  
                  <div *ngIf="addAnnouncementForm">
                      <form [formGroup]="sharePointForm" (ngSubmit)="saveSharePoint()">
                          <div style="margin: 20px;">
                              <div class="form-group mb-3" style="margin-right: 10px;">
                              <label for="firstName">Heading <span
                                      style="color: red;">*</span></label>
                              <!-- <mat-form-field style="width: 100%;margin:0;"> -->
                                  <input formControlName="title" class="form-control"
                                      />
                                  
                              <!-- </mat-form-field> -->
                              <div *ngIf="sharePointSubmit && shareControl.title.errors" class="ml-2">
                                  <div *ngIf="shareControl.title.errors.required" class="text-danger">
                                      Title required
                                  </div>
                                  <div *ngIf="shareControl.title.errors.noWhiteSpace" class="text-danger">
                                      {{ shareControl.title.errors.noWhiteSpace }}
                                  </div>
                              </div>
                          </div>
  
                              <div>
                                  <label for="firstName">Select User Type <span
                                          style="color: red;">*</span></label><br>
                                  <mat-checkbox *ngFor="let role of roleList?.roleType" color="primary"
                                      style="
                                      margin-right: 15px;" [checked]="selectedRoles.includes(role.id)"
                                      (change)="toggleRoleSelection(role.id)">{{role.role}}</mat-checkbox>
                                  <div *ngIf="isSelectedRoles" class="ml-2">
                                      <div class="text-danger">
                                          UserType required
                                      </div>
                                  </div>
                              </div>
  
  
                              <!-- <label style="font-weight: 100;margin-top: 5px;" for="firstName">User Type <span
                                      style="color: red;">*</span></label><br>
                              <mat-radio-group [(ngModel)]="rolevalue">
                                  <mat-checkbox *ngFor="let role of roleList?.roleType" style="margin-right: 15px;"
                                      [checked]="selectedRoles.includes(role.id)"
                                      (change)="toggleRoleSelection(role.id)">{{role.role}}</mat-checkbox>
                              </mat-radio-group>
                              <br /> -->
                              <label style="margin-top: 10px;" for="firstName">SharePoint Link
                                  <span style="color: red;">*</span></label><br>
                              <textarea formControlName="html" class="content-container" placeholder="SharePoint Link"
                                 ></textarea>
                              <div *ngIf="sharePointSubmit && shareControl.html.errors" class="ml-2">
                                  <div *ngIf="shareControl.html.errors.required" class="text-danger">
                                      SharePoint required
                                  </div>
                                  <div *ngIf="shareControl.html.hasError('pattern')" class="text-danger">
                                      Please enter a valid link.
                                  </div>
                              </div>
                              <br>
                              <label style="margin-top: 10px;" for="firstName">Notes
                              </label><br>
                              <textarea formControlName="notes" class="content-container" maxlength="150"
                                
                                  placeholder="Notes (100 characters)"></textarea>
                              <!-- <div *ngIf="sharePointSubmit && memberControl.notes.errors" class="ml-2">
                                  <div *ngIf="memberControl.notes.errors.required" class="text-danger">
                                      notes required
                                  </div>
                              </div> -->
  
                              <div class="form-group mb-3" style="margin-right: 10px;">
                                  <label for="roleType">Catagory </label>
                                  <select class="form-control" formControlName="catagory" id="roleType" placeholder="roleType" style="
                                                          padding-left: 15px;" (change)="oncatogorySelect($event)">
                                    <option value=0 >Select  Catogory</option>
                                    <!-- <option value="">Select State</option> -->
                                    <option *ngFor="let role of this.catagoryDropDown" value="{{role.categoryId}}" >{{role.categoryName}}</option>
                                  </select>
                                  
                                </div>
                                <div class="form-group mb-3" *ngIf="isPresent">
                                  <label for="roleType">Sub Catagory <span style="color: red;" *ngIf="this.subcategoryMap.length==0"> *</span></label>
                                  <!-- <select class="form-control" formControlName="subcatogorycatagory" id="roleType" placeholder="roleType" style="
                                                          padding-left: 15px;" (change)="onSubcatogorySelect($event)">
                                    <option value=0 >Select Sub Catogory</option>
                                   
                                    <option *ngFor="let role of  this.subCatagoryDropDown" value="{{role.categoryId}}" [disabled]="this.subcategoryMap.includes(role.categoryId)">{{role.categoryName}}</option>
                                    
                                  </select> -->
                                  <ng-select   class="custom-ng-select"
                                  bindLabel="name"                
                                  bindValue="id"
                                  placeholder="Select item"         
                                  formControlName="subcatogorycatagory"
                                  [multiple]="true"              
                                  [closeOnSelect]="false"
                                  (change)="onSelectGroups($event,'sub')" >
                                <ng-option [value]="'all'" [disabled]="allhideSubAll "  *ngIf="this.subcategoryMap.length==0 && subCatagoryDropDown.length!=1"  >
                                  All
                                </ng-option>
                                 <ng-option *ngFor="let role of subCatagoryDropDown" 
                                 [value]="role.categoryId" 
                                 [disabled]="allhideSub || this.subcategoryMap.includes(role.categoryId)">
                                 {{role.categoryName}}
                                </ng-option>
                              
                                </ng-select> 
                                  
                                </div>
                                <div class="form-group mb-3"  >
                                  <label>Vendor Group</label>
                                  <!-- <select class="form-control" id="groupId" formControlName="groupId">
                                      <option value=0 disabled selected>Select Group</option>
                                      <option *ngFor="let group of this.groupList" value="{{this.group.id}}" [disabled]="this.vendorMap.includes(group.id) && !this.isShow">{{ group.name }}</option>
                                    </select> -->
                               <ng-select  style="font-size: 1rem;"  class="custom-ng-select"
                                bindLabel="name"                
                                bindValue="id"
                                placeholder="Select item"         
                                formControlName="groupId"
                                [multiple]="true"              
                                [closeOnSelect]="false"
                                
                                (change)="onSelectGroups($event,'group')" >
                              <ng-option [value]="'all'" [disabled]="allhidegroupAll"  *ngIf="this.vendorMap.length==0 && groupList.length!=1  ">
                                  All
                              </ng-option>
                               <ng-option *ngFor="let group of groupList" 
                               [value]="group.id" 
                               [disabled]="allhide ||  this.vendorMap.includes(group.id)">
                               {{ group.name }}
                              </ng-option>
                            
                              </ng-select>  
  
                                  
                                </div>
                          </div>
                          
                          <div class="footer-modal">
                              <button [disabled]="!checkAllFieldsEnteredSharepoint()" class="sync-btn">
                                  <span>Submit</span>
                              </button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
  
      </div>
                    
  </div>
</div>